import {Component, OnInit} from '@angular/core';
import {ActivatedRouteSnapshot, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ToastyConfig} from 'ng2-toasty';

@Component({
  selector: 'app-root',
  template: `
    <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.15" [maximum]="1" [speed]="'200'" [showSpinner]="'false'"
                 [direction]="'leftToRightIncreased'" [trickleSpeed]="250" [thick]="false" [ease]="'linear'"
                 [color]="'#00e2ff'"></ng-progress>
    <ng2-toasty></ng2-toasty>
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private titleService: Title,
              private toastyConfig: ToastyConfig) {
    // Assign the selected theme name to the `theme` property of the instance of ToastyConfig.
    // Possible values: default, bootstrap, material
    this.toastyConfig.theme = 'default';
  }

  /**
   * Al iniciar la aplicación realizar configuraciones correspondientes.
   */
  ngOnInit() {
    this.eventTitleSubscriber();
  }

  /**
   * Modificación del titulo de la aplicacion
   * @param routeSnapshot
   * @returns {string}
   */
  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'App';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private eventTitleSubscriber() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let title: string = this.getPageTitle(this.router.routerState.snapshot.root);
        if (!title && this.titleService.getTitle()) {
          title = this.titleService.getTitle();
        }
        this.titleService.setTitle(title);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts